var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"testPaper"},[_c('div',{staticClass:"textPater-header"},[_c('div',{staticClass:"page-module"},[_c('p',[_vm._v(_vm._s(_vm.testPaperNavTititle))])])]),_c('div',{staticClass:"testPaper-main"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }